import api from "./index.js";

export function cashPass(data) {
  return api.post("/park/home/record/cashPass", data);
}

// 边缘服务器
// 分页查询全部订单记录
export function edgeOrderList(data) {
  return api({
    url: "/park/web/stopOrder/pageList",
    method: "post",
    data,
  });
}

/**
 * 除法函数，用来得到精确的除法结果
 * @param {Object} arg1
 * @param {Object} arg2
 */
export function numDivide(arg1, arg2) {
  const t1 = deal(arg1);
  const t2 = deal(arg2);
  const r1 = Number(arg1.toString().replace(".", ""));
  const r2 = Number(arg2.toString().replace(".", ""));
  return (r1 / r2) * Math.pow(10, t2 - t1);
}

/**
 * 求小数点后的数据长度
 */
function deal(arg) {
  let t = 0;
  try {
    t = arg.toString().split(".")[1].length;
  } catch (e) {}
  return t;
}



//车辆管理类型列表接口

export function mngTypeList(data){
  return api.get('/park/comm/mngType/list',{params:data})
}

// 多位多车详情
export function multCarDetailList(data) {
  return api({
    url: "/park/web/multCar/detailList",
    method: "post",
    data,
  });
}

// 进出记录详情
export function parkInAndOutDetails(data) {
  return api({
    url: "/park/web/passOutRecord/details",
    method: "get",
    params: data,
  });
}
